require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./biotechnologies-bioingnierie-edbb-2-3-4-2.json") })
        }
      }, "path---biotechnologies-bioingnierie-edbb-2-3-4-2");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---biotechnologies-bioingnierie-edbb-2-3-4-2!./.cache/json/biotechnologies-bioingnierie-edbb-2-3-4-2.json
// module id = 350
// module chunks = 231608221292675